import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=cc737816&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=cc737816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc737816",
  null
  
)

export default component.exports